export const initialState = {
	activeQuery: '',
	queryValue: '',
	activeCategories: '',
	activeCategoriesObj: [],
	categories: [],
	activeTools: '',
	activeToolsObj: [],
	tools: [],
	currentPage: '',
	totalPages: '',
	totalResults: '', 
	pending: false,
	activeOrderBy: '',
}
